import * as React from "react";
import { HoverCard as HoverCardPrimitive } from "radix-ui";
import { cn } from "@/lib/utils";

const HoverCard = (props) => {
  return <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
};

const HoverCardTrigger = (props) => {
  return <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
};

const HoverCardContent = ({ className, align = "start", side = "right", sideOffset = 8, ...props }) => {
  return (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content
        data-slot="hover-card-content"
        align={align}
        side={side}
        sideOffset={sideOffset}
        className={cn(
          "!z-[999] w-44 origin-(--radix-hover-card-content-transform-origin) rounded-lg border border-border-primary bg-background-secondary p-2 shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          className,
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
};

export { HoverCard, HoverCardContent, HoverCardTrigger };
